import {ORGANIZATION_ID} from "../const";

export const URL_HOME = "/";
export const URL_LEGAL_NOTICE = "/impressum";
export const URL_PRIVACY_POLICY = "/datenschutz";
// other
export const URL_BASE = "/" + ORGANIZATION_ID;
// attendees
export const URL_CUSTOMERS = URL_BASE + "/customers";
export const URL_ATTENDEES = URL_CUSTOMERS + "/attendees";
export const URL_BOOKERS = URL_CUSTOMERS + "/bookers";
export const URL_CUSTOMERS_DUPLICATES = URL_CUSTOMERS + "/duplicates";
export const URL_ATTENDEES_CREATE = URL_ATTENDEES + "/create";
export const URL_ATTENDEES_EDIT = URL_ATTENDEES + "/edit";
export const URL_ATTENDEES_EDIT_ID = URL_ATTENDEES + "/edit/:id";
export const URL_BOOKERS_CREATE = URL_BOOKERS + "/create";
export const URL_BOOKERS_EDIT = URL_BOOKERS + "/edit";
export const URL_BOOKERS_EDIT_ID = URL_BOOKERS + "/edit/:id";
export const URL_BOOKERS_DETAILS_ID = URL_BOOKERS + "/details/:id";
export const URL_BOOKERS_DETAILS_ATTENDEES_ID = URL_BOOKERS + "/details/attendee/:id";
// courses
export const URL_COURSES = URL_BASE + "/courses";
export const URL_COURSES_CREATE = URL_COURSES + "/create"; // default page
export const URL_COURSES_CREATE_FROM_ID = URL_COURSES + "/create/from/:id";
export const URL_COURSES_EDIT = URL_COURSES + "/edit";
export const URL_COURSES_EDIT_ID = URL_COURSES + "/edit/:id";
export const URL_COURSES_DETAILS_ID = URL_COURSES + "/coursedetails/:id";
export const URL_COURSES_DETAILS_ID_REFACTORED = URL_COURSES + "/coursedetailsrefactored/:id";
export const URL_COURSES_PREREQUISITE = URL_COURSES + "/prerequisite";
export const URL_COURSES_BULK_SEND = URL_COURSES + "/bulkSend";
// discountCodes (Beta „Rabattcodes“)
export const URL_COURSES_DISCOUNT_CODES = URL_COURSES + "/discount-codes";
export const URL_COURSES_DISCOUNT_CODES_CREATE = URL_COURSES + "/discount-codes/create";
export const URL_COURSES_DISCOUNT_CODES_CREATE_FROM_ID = URL_COURSES + "/discount-codes/create/from/:id";
export const URL_COURSES_DISCOUNT_CODES_EDIT_ID = URL_COURSES + "/discount-codes/edit/:id";
export const URL_COURSES_DISCOUNT_CODES_DETAILS_ID = URL_COURSES + "/discount-codes/details/:id";

// courseTypes
export const URL_COURSES_TYPES = URL_COURSES + "/types";
export const URL_COURSES_TYPES_CREATE = URL_COURSES + "/types/create";
export const URL_COURSES_TYPES_EDIT = URL_COURSES + "/types/edit";
export const URL_COURSES_TYPES_EDIT_ID = URL_COURSES + "/types/edit/:id";
// courseCategories
export const URL_COURSES_CATEGORIES = URL_COURSES + "/categories";
export const URL_COURSES_CATEGORIES_CREATE = URL_COURSES + "/categories/create";
export const URL_COURSES_CATEGORIES_EDIT = URL_COURSES + "/categories/edit";
export const URL_COURSES_CATEGORIES_EDIT_ID = URL_COURSES + "/categories/edit/:id";

// locations
export const URL_LOCATIONS = URL_BASE + "/locations";
export const URL_LOCATIONS_CREATE = URL_LOCATIONS + "/create";
export const URL_LOCATIONS_OVERVIEW = URL_LOCATIONS + "/overview";
export const URL_LOCATIONS_EDIT = URL_LOCATIONS + "/edit/:id";
export const URL_LOCATIONS_CONTACTS = URL_LOCATIONS + "/contacts";
// bookings
export const URL_BOOKINGS = URL_BASE + "/bookings";
export const URL_BOOKING_CREATE = URL_BOOKINGS + "/create";
export const URL_BOOKING_EDIT_ID = URL_BOOKINGS + "/edit/:id";
export const URL_BOOKINGS_COURSE_LIST = URL_BOOKINGS + "/courseList";
export const URL_BOOKINGS_LIST = URL_BOOKINGS + "/bookings/list";
export const URL_BOOKINGS_SETTLEMENT_DETAILS = URL_BOOKINGS + "/settlementDetails/:id";
// lessonBookings
export const URL_LESSON_BOOKINGS = URL_BOOKINGS + "/lessonBookings";
export const URL_LESSON_BOOKING_CREATE = URL_LESSON_BOOKINGS + "/create";
export const URL_LESSON_BOOKING_EDIT_ID = URL_LESSON_BOOKINGS + "/edit/:id";
export const URL_LESSON_BOOKINGS_SETTLED_DETAILS = URL_LESSON_BOOKINGS + "/settlementDetails/:id";
// MyBookings
export const URL_MY_BOOKINGS = URL_BASE + "/mybookings";
export const URL_MY_BOOKINGS_LIST = URL_MY_BOOKINGS + "/list";
export const URL_MY_BOOKINGS_CREATE = URL_MY_BOOKINGS + "/create";
export const URL_MY_BOOKINGS_EDIT = URL_MY_BOOKINGS + "/edit";
export const URL_MY_BOOKINGS_EDIT_ID = URL_MY_BOOKINGS + "/edit/:id";
export const URL_MY_BOOKINGS_COURSE_LIST = URL_MY_BOOKINGS + "/courseList";
// Instuctor specific
export const URL_INSTRUCTOR = URL_BASE + "/instructor";
export const URL_INSTRUCTOR_BOOKING_EDIT_ID = URL_INSTRUCTOR + "/edit/:id";
export const URL_INSTRUCTOR_INVOICE_SETTLEMENT_DETAILS = URL_INSTRUCTOR + "/settlementDetails/:id";
// staff
export const URL_STAFF = URL_BASE + "/staff";
export const URL_STAFF_CREATE = URL_STAFF + "/create";
export const URL_STAFF_OVERVIEW = URL_STAFF + "/edit";
export const URL_STAFF_EDIT = URL_STAFF + "/edit/:id";
export const URL_STAFF_BILLING_STATUS = URL_STAFF + "/billingStatus";
export const URL_STAFF_ADMINS = URL_STAFF + "/admins";
// staffLogin
export const URL_STAFF_LOGIN = URL_BASE + "/staffLogin";
export const URL_STAFF_LOGIN_START = URL_STAFF_LOGIN + "/start";
export const URL_STAFF_LOGIN_FILES = URL_STAFF_LOGIN + "/files";
// settings
export const URL_SETTINGS = URL_BASE + "/settings";
export const URL_SETTINGS_APP = URL_SETTINGS + "/app";
export const URL_SETTINGS_COMPANY = URL_SETTINGS + "/company";
// Neue Einstellungsseite mit Bereichen (docs/sketches/settings-structure), Bereich als /general/<areaId>
export const URL_SETTINGS_GENERAL = URL_SETTINGS + "/general";
export const URL_SETTINGS_ENDUSERAPP = URL_SETTINGS + "/enduserapp";
export const URL_SETTINGS_ADMIN = URL_SETTINGS + "/admin";
export const URL_SETTINGS_IMPORT_BOOKERS = URL_SETTINGS + "/importBookers";
export const URL_SETTINGS_MAINTENANCE = URL_SETTINGS + "/maintenance";
// v2.2 Block 4 — Superuser-only Mollie-Developer-Docs
export const URL_SETTINGS_MOLLIE_DEV_DOCS = URL_SETTINGS + "/mollie-dev-docs";
export const URL_SETTINGS_MONITORING = URL_SETTINGS + "/monitoring";
export const URL_SETTINGS_MCP = URL_SETTINGS + "/ki-assistent";
export const URL_SETTINGS_DATA_EXPORT = URL_SETTINGS + "/data-export";
export const URL_SETTINGS_INVOICE_EXPORT = URL_SETTINGS + "/invoice-export";
// login
export const URL_LOGIN = URL_BASE + "/login";
export const URL_LOGIN_PARAMS = URL_LOGIN + "/:code?";
// assistant app
export const URL_ASSISTANT = URL_BASE + "/assistant";
export const URL_ASSISTANT_LOGIN = URL_ASSISTANT + "/login";
export const URL_ASSISTANT_HOME = URL_ASSISTANT + "/home";
export const URL_ASSISTANT_MY = URL_ASSISTANT + "/my";
export const URL_ASSISTANT_PROFILE = URL_ASSISTANT + "/profile";
export const URL_ASSISTANT_CHANGELOG = URL_ASSISTANT + "/changelog";
// welcome page
export const URL_WELCOME_PAGE = URL_BASE + "/welcome";
// initial setup creation
export const URL_SETUP = URL_BASE + "/setup";
export const URL_SETUP_CREATE_PROFILE = URL_SETUP + "/create-profile";
// invoice
export const URL_INVOICE = URL_BASE + "/invoice";
export const URL_INVOICE_LIST_BY_COURSE = URL_INVOICE + "/list/bybooking/unsettled";
export const URL_INVOICE_LIST_BY_BOOKING_UNSETTLED = URL_INVOICE + "/list/bycourse";
export const URL_INVOICE_COURSE_DETAILS = URL_INVOICE + "/list/coursedetails/:id";
export const URL_INVOICE_SETTLEMENT_DETAILS = URL_INVOICE + "/list/settlementDetails/:id";
export const URL_INVOICE_LIST_BY_BOOKING_SETTLED = URL_INVOICE + "/list/bybooking/settled";
export const URL_INVOICE_LIST_BY_BOOKING_CANCELED = URL_INVOICE + "/list/bybooking/reversals";
// templates
export const URL_TEMPLATES = URL_BASE + "/templates";
export const URL_TEMPLATES_EMAIL = URL_TEMPLATES + "/email";
export const URL_TEMPLATES_INVOICES = URL_TEMPLATES + "/invoices";
export const URL_TEXT_MODULES = URL_TEMPLATES + "/textModules";
export const URL_TEMPLATES_CREATE = URL_TEMPLATES + "/create";
export const URL_TEMPLATES_EDIT = URL_TEMPLATES + "/edit";
// payments
export const URL_PAYMENTS = URL_BASE + "/payments";
export const URL_OPEN = URL_PAYMENTS + "/open";
export const URL_PAID = URL_PAYMENTS + "/paid";
export const URL_IMPORT_HISTORY = URL_PAYMENTS + "/import-history";
// Phase 14 Plan 14-03 (REFD-07, REFD-08) — Refund-Übersichts-Liste
export const URL_PAYMENTS_REFUNDS = URL_PAYMENTS + "/refunds";
// Phase 16 Plan 16-05 (REPORT-01) — Mollie Zahlungen Zentrale
export const URL_MOLLIE_PAYMENTS = URL_PAYMENTS + "/mollie";
// Phase 16 Plan 16-06 (REPORT-02/REPORT-04) — Chargebacks-Inbox (absorbiert Mollie-Retry-Queue)
export const URL_CHARGEBACKS = URL_PAYMENTS + "/chargebacks";
// Bankabgleich (Beta): Kontoumsätze hochladen und zuordnen
export const URL_PAYMENTS_BANK_IMPORT = URL_PAYMENTS + "/bank-import";
export const URL_PAYMENTS_TARIF595 = URL_PAYMENTS + "/krankenkassenbelege";
// Phase 14 Plan 14-03 (REFD-08 / D-21) — Ziel der Row-Click-Navigation
export const URL_BOOKINGS_DETAILS = URL_BOOKINGS + "/settlementDetails/:id";
// Widerrufe (Widerrufsbutton-Feature) — Admin-Verwaltung eingegangener Widerrufe
export const URL_WITHDRAWALS = URL_BASE + "/withdrawals";
export const URL_WITHDRAWALS_OVERVIEW = URL_WITHDRAWALS + "/overview";
export const URL_WITHDRAWALS_DETAILS_ID = URL_WITHDRAWALS + "/details/:id";
// interest lists (Interessenten-Listen, sc-3167)
export const URL_INTEREST_LISTS = URL_BASE + "/interest-lists";
export const URL_INTEREST_LISTS_MANAGE = URL_INTEREST_LISTS + "/lists";
export const URL_INTEREST_REGISTRATIONS = URL_INTEREST_LISTS + "/registrations";
export const URL_INTEREST_REGISTRATIONS_CREATE = URL_INTEREST_REGISTRATIONS + "/create";
// newsletter (Beta, Weg A0: Standortlisten im Mailjet-Konto des Kunden)
export const URL_NEWSLETTER = URL_BASE + "/newsletter";
export const URL_NEWSLETTER_OVERVIEW = URL_NEWSLETTER + "/overview";
export const URL_NEWSLETTER_SETTINGS = URL_NEWSLETTER + "/settings";
export const URL_NEWSLETTER_LISTS = URL_NEWSLETTER + "/lists";
// mollie retry queue (Phase 8)
export const URL_MOLLIE_RETRY_QUEUE = URL_BASE + "/mollie-retry-queue";
// notifications
export const URL_NOTIFICATIONS = URL_BASE + "/notifications";
export const URL_NOTIFICATIONS_SENT_MAILS = URL_NOTIFICATIONS + "/sent";
export const URL_NOTIFICATIONS_FIXER = URL_NOTIFICATIONS + "/fixer";
// end-user-app
export const URL_ACCOUNT = URL_BASE + "/account";
export const URL_ENDUSER = URL_ACCOUNT + "/enduser";
export const URL_FORGOT_PASSWORD = URL_ENDUSER + "/forgot-password/:changePasswordId/:resetPasswordUrl";
export const URL_RESET_PASSWORD_SUCCESS = URL_ENDUSER + "/forgot-password/success/:resetPasswordUrl";
// changeLog
export const URL_CHANGELOG = URL_BASE + "/changelog/:highestRole";
// badges
export const URL_BADGES = URL_BASE + "/badges";
export const URL_BADGES_CREATE = URL_BADGES + "/create";
export const URL_BADGES_ASSIGN = URL_BADGES + "/assign";
// certificates
export const URL_CERTIFICATES = URL_BASE + "/certificates";
export const URL_CERTIFICATES_ISSUED = URL_CERTIFICATES + "/issued";
export const URL_CERTIFICATES_TEMPLATES = URL_CERTIFICATES + "/templates";
export const URL_CERTIFICATES_TEMPLATES_CREATE = URL_CERTIFICATES_TEMPLATES + "/create";
export const URL_CERTIFICATES_TEMPLATES_EDIT = URL_CERTIFICATES_TEMPLATES + "/edit/:id";
// permissions
export const URL_PERMISSIONS = URL_BASE + "/permissions";
export const URL_PERMISSION_DENIED = URL_PERMISSIONS + "/denied";
// lessonsToday
export const URL_LESSONS_TODAY = URL_BASE + "/lessonsToday";
export const URL_LESSONS_TODAY_LIST = URL_LESSONS_TODAY + "/list";
export const URL_LESSONS_TODAY_CALENDAR = URL_LESSONS_TODAY + "/calendar";
export const URL_LESSONS_TODAY_CALENDAR_WEEKVIEW = URL_LESSONS_TODAY + "/weekview";
export const URL_LESSONS_TODAY_CALENDAR_DAYVIEW = URL_LESSONS_TODAY + "/dayview";
export const URL_LESSONS_TODAY_EXPORT_INSTRUCTOR_LESSONS = URL_LESSONS_TODAY + "/exportInstructorLessons";
export const URL_LESSONS_TODAY_MAIN = URL_LESSONS_TODAY + "/main";
// areaManager
export const URL_AREA_MANAGER = URL_BASE + "/areaManager";
export const URL_AREA_MANAGER_OVERVIEW = URL_AREA_MANAGER + "/overview";
export const URL_AREA_MANAGER_COURSES = URL_AREA_MANAGER + "/courses";
export const URL_AREA_MANAGER_INSTRUCTORS = URL_AREA_MANAGER + "/instructors";
export const URL_AREA_MANAGER_ASSISTANTS = URL_AREA_MANAGER + "/assistants";
export const URL_AREA_MANAGER_VENUES = URL_AREA_MANAGER + "/venues";
// dashboard
export const URL_DASHBOARD = URL_BASE + "/dashboard";
export const URL_DASHBOARD_OVERVIEW = URL_DASHBOARD + "/overview";

export const URL_HELP = URL_BASE + "/help";
